export default "/images/8f14e7c1195d7a218aaf1267fc1ead3f.avif";